import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Inject, Injectable, Injector } from '@angular/core';
import { ErrorsConstant } from '../constants/errors-const';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'src/environments/environment';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  errorMsg = '';
  constructor(private notification: NzNotificationService) {
  }

    // Handle API errors
  handleError(error: HttpErrorResponse): void {

    if (!navigator.onLine) {
      this.errorMsg = ErrorsConstant.NetworkIssue;
    } else if (error.status >= 400 && error.status <= 499) {
        
        if(environment.production){
            this.errorMsg = ErrorsConstant.ClientSide;
        }else{
            this.errorMsg = error.message;
        }
      
    } else {
        if(environment.production){
            this.errorMsg = ErrorsConstant.ServerSide;
        }else{
            this.errorMsg = error.message;
        }
      
    }
    // this.notification.create(
    //     'error',
    //     'Error',
    //     this.errorMsg
    //   );
    //this.toastrService.error(this.errorMsg, '');
  }

}